import { useSearchParams } from 'react-router-dom';
import { useEffect, useState } from 'react';

import { Theme } from '../contexts/ThemeContext';

export const useUrlParams = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const [theme, setTheme] = useState<Theme>('light');
  const [token, setToken] = useState<string>('');
  const [storedDataKey, setStoredDataKey] = useState<string>('');
  const [language, setLanguage] = useState<string>('en');
  const [sessionId, setSessionId] = useState<string>('');
  const [paymentCurrencyCode, setPaymentCurrencyCode] = useState<string>('BRL');

  useEffect(() => {
    const themeFromUrl = searchParams.get('theme');
    const tokenFromUrl = searchParams.get('token');
    const storedDataKeyFromUrl = searchParams.get('storedDataKey');
    const languageFromUrl = searchParams.get('lang');
    const sessionIdFromUrl = searchParams.get('session-id');
    const paymentCurrencyCodeFromUrl = searchParams.get('paymentCurrencyCode');

    if (tokenFromUrl) {
      setToken(tokenFromUrl);
      searchParams.delete('token');
      setSearchParams(searchParams);
    }

    if (storedDataKeyFromUrl) {
      setStoredDataKey(storedDataKeyFromUrl);
    }

    if (themeFromUrl && (themeFromUrl === 'light' || themeFromUrl === 'dark')) {
      setTheme(themeFromUrl);
    }

    if (languageFromUrl) {
      setLanguage(languageFromUrl);
    }

    if (sessionIdFromUrl) {
      setSessionId(sessionIdFromUrl);
    }

    if (paymentCurrencyCodeFromUrl) {
      setPaymentCurrencyCode(paymentCurrencyCodeFromUrl);
    }
  }, [searchParams, setSearchParams]);

  return { token, theme, storedDataKey, language, sessionId, paymentCurrencyCode };
};
